import { render } from "./CardAttachmentMediaUnknown.vue?vue&type=template&id=2096e97c"
import script from "./CardAttachmentMediaUnknown.vue?vue&type=script&lang=js"
export * from "./CardAttachmentMediaUnknown.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__